/**
 * Cấu hình DoctorAI theo type.
 * Thêm type mới: thêm entry vào DOCTOR_AI_TYPES với các hàm tương ứng.
 *
 * @typedef {Object} DoctorAITypeConfig
 * @property {(vm: Object) => string} storageKey - Key localStorage
 * @property {(vm: Object) => string|number|null} getContextId - ID dùng làm key trong rawData (question/answer/history)
 * @property {(vm: Object) => boolean} hasStorage - Có dùng localStorage không
 * @property {(vm: Object) => string[]} watchProps - Các prop cần watch để reload cache khi thay đổi
 * @property {(vm: Object) => string} getWelcomeMessageNoIssue - Welcome message khi không có issue
 */

const WELCOME_BASE = 'lbl_super_doc.lbl_welcome_msg'
const WELCOME_INFO = 'lbl_super_doc.lbl_welcome_info'
const WELCOME_FIELD_1 = 'lbl_super_doc.lbl_welcome_field_1'
const WELCOME_FIELD_2 = 'lbl_super_doc.lbl_welcome_field_2'

const defaultWelcomeMessage = vm => vm.$t(WELCOME_BASE) + vm.$t(WELCOME_INFO) + vm.$t(WELCOME_FIELD_1) + vm.$t(WELCOME_FIELD_2)

export const DOCTOR_AI_TYPES = {
  BENH_AN: {
    storageKey: vm => (vm.badtId ? `doctor_ai_badt_${vm.badtId}` : 'doctor_ai_badt'),
    getContextId: vm => vm.badtId,
    hasStorage: vm => !!vm.badtId,
    watchProps: ['badtId'],
    getWelcomeMessageNoIssue: defaultWelcomeMessage
  },
  HOI_CHAN: {
    storageKey: vm => {
      const sessionId = vm.sessionId
      return sessionId ? `doctor_ai_session_${sessionId}` : 'doctor_ai_session'
    },
    getContextId: vm => vm.diseaseId,
    hasStorage: vm => !!vm.sessionId && !!vm.diseaseId,
    watchProps: ['sessionId', 'diseaseId'],
    getWelcomeMessageNoIssue: defaultWelcomeMessage
  }
}

export const DEFAULT_TYPE_CONFIG = {
  storageKey: () => 'doctor_ai_default',
  getContextId: () => null,
  hasStorage: () => false,
  watchProps: [],
  getWelcomeMessageNoIssue: defaultWelcomeMessage
}

export function getTypeConfig (type) {
  return DOCTOR_AI_TYPES[type] || DEFAULT_TYPE_CONFIG
}
